import { Reveal } from "@/components/site/reveal";

const QUOTES = [
  {
    quote: "Karen's team didn't just care for my father — they became part of our family. He asks for his caregiver by name every morning.",
    name: "Margaret H.",
    role: "Daughter of a Personal Care client",
  },
  {
    quote: "After my surgery, the respite visits gave my husband his life back. Kind, punctual, and completely trustworthy.",
    name: "Dorothy & Alan P.",
    role: "Respite Care family",
  },
];

export default function Testimonials() {
  return (
    <section id="stories" data-testid="stories-section" className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex items-center gap-4 mb-16">
            <span className="h-px w-12 bg-navy" />
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-navy">
              Words from our families
            </span>
          </div>
        </Reveal>
        <div className="grid md:grid-cols-2 gap-16 md:gap-24">
          {QUOTES.map((q, i) => (
            <Reveal key={q.name} delay={i * 0.1}>
              <figure data-testid={`testimonial-${i + 1}`} className="border-l-2 border-navy pl-8 md:pl-10">
                <blockquote className="font-display italic font-light text-2xl md:text-3xl leading-snug text-navy-dark">
                  “{q.quote}”
                </blockquote>
                <figcaption className="mt-8">
                  <p className="text-sm font-bold text-navy-dark">{q.name}</p>
                  <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-navy-dark/50 mt-1.5">
                    {q.role}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
